import AppPage from "layouts/AppPage";
import { useParams, useSearchParams } from "react-router";
import { useEmailTemplateDetailQuery } from "features/Resources/EmailTemplate/hooks";
import { usePrebuiltEmailTemplateDetailQuery } from "features/Prebuilt/PrebuiltSharedTemplate/hooks";
import EmailTemplateForm from "features/Resources/EmailTemplate/Layout/EmailTemplateForm";
import PrebuiltEmailTemplateDisplay from "features/Resources/EmailTemplate/Layout/PrebuiltEmailTemplateDisplay";
import { useMemo } from "react";
import CaminoBreadcrumbs from "components/Breadcrumbs";
import { PEOPLE_TEAM_ROUTES } from "definitions/constants/routeConstants";
import { truncateEnd } from "helpers/string";

export default function EmailTemplatePage() {
  const { id } = useParams<{ id: string; }>();
  const [searchParams] = useSearchParams();
  const { data = {}, isLoading } = useEmailTemplateDetailQuery(id, {
    enabled: !!id && id !== "new",
  });
  const pathId = searchParams.get("pathId") ?? undefined;

  const formData = useMemo(() => {
    if (id === "new" && pathId) {
      return { paths: [{ id: pathId }] };
    }
    return data || {};
  }, [id, pathId, data]);

  if (!id) {
    // TODO: Redirect to 404
    return <AppPage>Template not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  return (
    <AppPage>
      <CaminoBreadcrumbs
        breadcrumbInfos={[
          { name: "Email Templates", toUrl: PEOPLE_TEAM_ROUTES.emailTemplates.index },
          { name: id === "new" ? "New" : `${truncateEnd(data?.name)}` },
        ]}
      />
      {(data || id === "new") && (
        <EmailTemplateForm id={id} data={formData} />
      )}
    </AppPage>
  );
}

export function PrebuiltEmailTemplatePage() {
  const { id } = useParams<{ id: string; }>();
  const { data, isLoading } = usePrebuiltEmailTemplateDetailQuery(id!);

  if (!id) {
    // TODO: Redirect to 404
    return <AppPage>Template not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  return (
    <AppPage>
      {data && (
        <PrebuiltEmailTemplateDisplay prebuiltEmailTemplate={data} />
      )}
    </AppPage>
  );
}
